module.exports = __webpack_public_path__ + "img/阵雪.059281fa.png";